import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import {
  type IActionItemByEquipment,
  type IActionItemsByEquipmentKeys,
} from '../model/actionItemsByEquipment';

const actionItemsByEquipmentKey = (
  keys: IActionItemsByEquipmentKeys,
): [string, number, Array<number> | undefined, ITableSorting] => [
  'actionItemsByEquipment',
  keys.equipmentId,
  keys.locationIds,
  keys.sorting,
];

const actionItemsByEquipmentFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof actionItemsByEquipmentKey>>) => {
  const orderBy = queryKey[3].id ? queryKey[3].id : undefined;
  const direction = !queryKey[3].id ? undefined : queryKey[3].desc ? 'desc' : 'asc';

  const params = {
    location_ids: queryKey[2],
    sort: {
      field: orderBy,
      direction: direction,
    },
  };

  return apiClient.get<{ data: IActionItemByEquipment[] }>(
    `${APP_API_URL_V2}fsd/action-item/asset-health/equipment/${queryKey[1]}/action-items`,
    {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    },
  );
};

const actionItemsByEquipmentSelect = ({ data }: AxiosResponse<{ data: IActionItemByEquipment[] }>) => {
  if (!data.data) {
    return [];
  }
  return data.data;
};

export const useActionItemsByEquipmentQuery = (keys: IActionItemsByEquipmentKeys) => {
  return useQuery({
    queryKey: actionItemsByEquipmentKey(keys),
    queryFn: actionItemsByEquipmentFn,
    enabled: keys.enabled,
    select: actionItemsByEquipmentSelect,
  });
};
